export default {
	TOTEM_NAVIGATION_COMMUNICATIONS: 'Comunicazioni',
	TOTEM_NAVIGATION_DOCUMENTS: 'Documenti',

	TOTEM_HEADER_DOCUMENTS_TITLE: 'Documenti pubblici',
	TOTEM_HEADER_NEWS_TITLE: 'Comunicazioni pubbliche',

	TOTEM_CARD_FOLDER_UP: 'Cartella precedente',
	TOTEM_CARD_FOLDER_TYPE: 'Cartella'
};
